export default __webpack_public_path__ + "static/media/profile.69c1caf0.svg";